export default [
  [
    {
      id: 'startDestination',
      label: 'ขนจาก (ต้นทาง) *',
      span: 7,
      type: 7,
      props: { margin: '0 40px 0 0', width: '100%', title: { text: 'ขนจาก (ต้นทาง)' } },
    }, {
      id: 'startDestinationText',
      span: 5,
      type: 8,
      props: { margin: '32px 0 0', width: '100%', display: 'block' },
    },
    {
      id: 'endDestination',
      label: 'ขนไป (ปลายทาง) *',
      span: 7,
      type: 7,
      props: { margin: '0 40px 0 0', width: '100%', title: { text: 'ขนจาก (ต้นทาง)' } },
    }, {
      id: 'endDestinationText',
      span: 5,
      type: 8,
      props: { margin: '32px 0 0', width: '100%', display: 'block' },
    }, {
      id: 'availableOrder',
      span: 6,
      type: 13,
      label: 'จำนวนใบสั่งบรรทุกที่สามารถสร้างได้',
    }, {
      id: 'shippings',
      span: 6,
      type: 13,
      label: 'จำนวนใบสั่งบรรทุกที่สร้างไปแล้ว',
    }, {
      id: 'remainingOrder',
      span: 6,
      type: 13,
      label: 'จำนวนใบสั่งบรรทุกที่เหลือ',
    }, {
      id: 'containerOption',
      label: 'จำนวนตู้บรรทุก',
      span: 6,
      type: 9,
      defaultValue: 'NONE',
      props: { margin: '0 40px 0 0', width: '100%', title: { text: 'จำนวนตู้บรรทุก' } },
      children: [
        {
          value: 'NONE',
          text: 'ไม่มี',
        }, {
          value: 'ONE',
          text: '1 ตู้',
        }, {
          value: 'TWO',
          text: '2 ตู้',
        },
      ],
    },
  ], [
    {
      id: 'compensation',
      label: 'เบี้ยเลี้ยง',
      dataType: 'float',
      span: 6,
      type: 0,
      props: { margin: '0 40px 0 0', width: '100%', title: { text: 'เบี้ยเลี้ยง *' } },
    }, {
      label: 'บาท',
      span: 2,
      type: 8,
      props: { margin: '32px 0 0', width: '100%', display: 'block' },
    }, {
      id: 'weightDifferenceLimit',
      label: 'น้ำหนักขาดเกิน ไม่เกิน',
      dataType: 'float',
      span: 6,
      offset: 4,
      type: 0,
      props: { margin: '0 40px 0 0', width: '100%', title: { text: 'น้ำหนักขาดเกิน ไม่เกิน *' } },
    }, {
      label: 'กิโลกรัม',
      span: 2,
      type: 8,
      props: { margin: '32px 0 0', width: '100%', display: 'block' },
    },
  ],
]

export const Remarks = [
  [
    {
      id: 'remark', // textArea
      label: 'หมายเหตุ',
      span: 12,
      type: 6,
      props: { margin: '0 40px 0 0', width: '100%', title: { text: 'หมายเหตุ' } },
    }, {
      id: 'images', // Upload
      label: 'Attachments',
      span: 24,
      type: 4,
      props: { margin: '0 8px 0 0' },
    },
  ],
]
